import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, CalendarDays } from 'lucide-react';

const DOT = { pending: 'bg-gold', approved: 'bg-emerald-400', changes: 'bg-heart', posted: 'bg-cream/40' };
const DAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export default function PostCalendar({ posts, quota }) {
  const [cur, setCur] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const y = cur.getFullYear(), m = cur.getMonth();
  const first = new Date(y, m, 1).getDay();
  const days = new Date(y, m + 1, 0).getDate();
  const inMonth = (p) => { if (!p.scheduled_for) return false; const d = new Date(p.scheduled_for); return d.getFullYear() === y && d.getMonth() === m; };
  const monthPosts = posts.filter(inMonth);
  const byDay = {};
  monthPosts.forEach((p) => { const d = new Date(p.scheduled_for).getDate(); (byDay[d] = byDay[d] || []).push(p); });
  const used = monthPosts.filter((p) => p.status !== 'changes').length;
  const label = cur.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

  return (
    <div className="panel rounded-3xl p-6" data-testid="post-calendar">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <p className="flex items-center gap-2 font-display text-2xl text-cream"><CalendarDays size={18} className="text-gold" /> Content calendar</p>
        <div className="flex items-center gap-2">
          <button onClick={() => setCur(new Date(y, m - 1, 1))} data-testid="calendar-prev" className="btn-ghost rounded-full p-1.5"><ChevronLeft size={14} /></button>
          <span className="text-sm text-cream min-w-[130px] text-center" data-testid="calendar-month">{label}</span>
          <button onClick={() => setCur(new Date(y, m + 1, 1))} data-testid="calendar-next" className="btn-ghost rounded-full p-1.5"><ChevronRight size={14} /></button>
        </div>
      </div>
      {quota ? (
        <div className="mt-3">
          <div className="flex items-center justify-between text-xs text-cream/60"><span data-testid="calendar-quota">{used} of {quota} posts this month</span><span>{Math.max(0, quota - used)} left</span></div>
          <div className="mt-1.5 h-1.5 rounded-full bg-cream/10 overflow-hidden"><div className="h-full bg-gold transition-all" style={{ width: `${Math.min(100, (used / quota) * 100)}%` }} /></div>
        </div>
      ) : <p className="mt-2 text-xs text-cream/50">{monthPosts.length} {monthPosts.length === 1 ? 'post' : 'posts'} this month</p>}
      <div className="mt-4 grid grid-cols-7 gap-1 text-center">
        {DAYS.map((d, i) => <div key={i} className="text-[10px] text-cream/40 py-1">{d}</div>)}
        {Array.from({ length: first }).map((_, i) => <div key={`e${i}`} />)}
        {Array.from({ length: days }).map((_, i) => {
          const d = i + 1, list = byDay[d] || [];
          const today = new Date().toDateString() === new Date(y, m, d).toDateString();
          return (
            <div key={d} data-testid={`calendar-day-${d}`} title={list.map((p) => `${p.platform}: ${p.status}`).join('\n')} className={`aspect-square rounded-lg border text-xs flex flex-col items-center justify-center gap-1 ${today ? 'border-gold/60' : 'hairline'} ${list.length ? 'bg-panel2/60' : ''}`}>
              <span className={today ? 'text-gold' : 'text-cream/70'}>{d}</span>
              {list.length > 0 && <span className="flex gap-0.5">{list.slice(0, 4).map((p) => <span key={p.id} className={`w-1.5 h-1.5 rounded-full ${DOT[p.status] || 'bg-cream/40'}`} />)}</span>}
            </div>
          );
        })}
      </div>
      <div className="mt-3 flex gap-3 flex-wrap text-[10px] text-cream/50">
        {Object.entries({ pending: 'Needs your OK', approved: 'Approved', changes: 'Changes requested', posted: 'Posted' }).map(([k, v]) => <span key={k} className="flex items-center gap-1"><span className={`w-1.5 h-1.5 rounded-full ${DOT[k]}`} /> {v}</span>)}
      </div>
    </div>
  );
}
